import client from './client';
import type { ApiResponse, User } from '@/types';

export const authApi = {
  login: (identifier: string, password: string) =>
    client.post<ApiResponse<{ accessToken: string; refreshToken: string; user: User }>>(
      '/auth/login',
      { identifier, password },
    ),

  me: () => client.get<ApiResponse<User>>('/auth/me'),

  registerParent: (data: {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    studentCode: string;
  }) =>
    client.post<ApiResponse<{ accessToken: string; refreshToken: string; user: User }>>(
      '/auth/register-parent',
      data,
    ),

  logout: (refreshToken: string) =>
    client.post('/auth/logout', { refreshToken }),

  changePassword: (currentPassword: string, newPassword: string) =>
    client.patch('/auth/change-password', { currentPassword, newPassword }),

  forgotPassword: (email: string) =>
    client.post('/auth/forgot-password', { email }),

  resetPassword: (token: string, password: string) =>
    client.post('/auth/reset-password', { token, password }),
};
